import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "box",
  "use": "box-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"box\"><path d=\"M12 0L1 6v12.131L12 24l11-5.869V6.065L12 0zm-1 21.2l-6.664-3.555 4.201-2.801c1.08-.719-.066-2.359-1.243-1.575L3 16.131V8.23l8 4.363V21.2zM4.133 6.57L11 2.824V7.25c0 1.323 2 1.324 2 0V2.835l6.91 3.811-7.905 4.218L4.133 6.57zM13 12.6l8-4.269v7.8l-4.263-2.842c-1.181-.785-2.323.855-1.245 1.574l4.172 2.781L13 21.2v-8.6z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol